<div class="fixed inset-0 z-40 bg-[#101828]/70 backdrop-blur-[2px]" (click)="close()" aria-hidden="true">
</div>

<div class="fixed inset-0 z-50 flex items-center justify-center px-4 pointer-events-none"
    *transloco="let t; currentLang as currentLang">
    <div class="max-h-[calc(100dvh-32px)] w-full max-w-[480px] overflow-y-auto bg-white rounded-2xl py-4 px-3 sm:h-[227px] sm:w-[480px] sm:max-w-none sm:overflow-visible sm:px-4 sm:py-[20px] pointer-events-auto border border-[#E4E7EC]"
        role="document" (click)="$event.stopPropagation()">

        <div class="relative mb-3 flex items-center justify-between">
            <h2
                class="absolute left-1/2 -translate-x-1/2 whitespace-nowrap text-[16px] font-semibold text-[#344054] sm:text-[18px]">
                {{ t('shareThisJob') }}</h2>

            <button type="button" (click)="close()" [attr.aria-label]="t('closeShareDialog')" class="ml-auto flex h-7 w-7 translate-x-0 -translate-y-3 items-center justify-center rounded-full
               text-[#667085] hover:bg-[#F2F4F7] transition-colors cursor-pointer
               focus-visible:outline focus-visible:outline-2
                    focus-visible:outline-offset-2 focus-visible:outline-[#0E6596] sm:-translate-y-4 sm:translate-x-3">
                <svg aria-hidden="true" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <hr class="flex-1  mb-[28px] border-t border-[#E4E7EC]">

        <div class="mb-[16px] grid grid-cols-3 gap-2 sm:gap-4" [class.grid-cols-2]="!showWhatsapp()">

            <!-- Facebook -->
            <button type="button" (click)="shareOnFacebook()" class="flex h-9 min-w-0 w-full items-center justify-center gap-1 rounded-lg px-2 py-2 text-xs sm:h-[48px] sm:gap-2 sm:rounded-[12px] sm:px-4 sm:py-3 sm:text-sm
                    border border-[#CCE5FF] bg-[#F5FAFF]
               hover:bg-[#F5F8FF] hover:border-[#B2CCFF]
               transition-all text-sm font-semibold text-[#1877F2] cursor-pointer
               focus-visible:outline focus-visible:outline-2
               focus-visible:outline-offset-2 focus-visible:outline-[#1877F2]">
                <svg aria-hidden="true" class="h-4 w-4 shrink-0 sm:h-5 sm:w-5" fill="#1877F2" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99
               4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007
               1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83
               c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385
               C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
                facebook
            </button>

            <!-- LinkedIn -->
            <button type="button" (click)="shareOnLinkedIn()" class="flex h-9 min-w-0 w-full items-center justify-center gap-1 rounded-lg px-2 py-2 text-xs sm:h-[48px] sm:gap-2 sm:rounded-[12px] sm:px-4 sm:py-3 sm:text-sm
                    border border-[#CCE5FF] bg-[#F5FAFF]
               hover:bg-[#F2F8FF] hover:border-[#CCE6FF]
               transition-all text-sm font-semibold text-[#0A66C2] cursor-pointer
               focus-visible:outline focus-visible:outline-2
               focus-visible:outline-offset-2 focus-visible:outline-[#0A66C2]">
                Linked
                <svg aria-hidden="true" class="h-4 w-4 shrink-0 sm:h-5 sm:w-5" fill="#0A66C2" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037
                                   -1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046
                                   c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286z
                                   M5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065z
                                   m1.782 13.019H3.555V9h3.564v11.452z
                                   M22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24
                                   1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0
                                   22.222 0h.003z" />
                </svg>
            </button>

            @if (showWhatsapp()) {
            <button type="button" (click)="shareOnWhatsapp()" class="flex h-9 min-w-0 w-full items-center justify-center gap-1 rounded-lg px-2 py-2 text-xs sm:h-[48px] sm:gap-2 sm:rounded-[12px] sm:px-4 sm:py-3 sm:text-sm
                    border border-[#C8F0D5] bg-[#F3FFF6] text-[#128C45] hover:bg-[#ECFFF1] cursor-pointer
               transition-all text-sm font-semibold focus-visible:outline focus-visible:outline-2
               focus-visible:outline-offset-2 focus-visible:outline-[#25D366]">
                <span class="icon-whatsapp text-xs sm:text-sm" aria-hidden="true"></span>
                <span class="text-[10px] sm:text-[14px] ">WhatsApp</span>
            </button>
            }

        </div>

        <div class="flex items-center gap-2 w-full">

            <!-- Link -->
            <div
                class="flex-1 min-w-0 sm:h-[52px] h-[38px] rounded-xl sm:rounded-[8px] border border-[#E4E7EC] bg-white px-2 sm:px-[10px] py-3 flex items-center">

                <span class="text-xs sm:text-[14px] text-[#667085] truncate select-all block w-full">
                    {{ jobUrl() }}
                </span>

            </div>

            <!-- Copy Button -->
            <button type="button" (click)="copyLink()"
                [class]="copyLabel() === copiedKey
            ? 'flex items-center justify-center gap-1.5 py-2.5 px-3 w-[93px] sm:h-[52px] h-[38px] shrink-0 rounded-[8px] sm:rounded-xl cursor-pointer border border-[#E2F2FC]  bg-white hover:bg-[#F5FAFF] text-[#0E6596] text-sm font-semibold transition-colors overflow-hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0E6596]'
            : 'flex items-center justify-center gap-1.5 w-[80px] sm:h-[52px] shrink-0 rounded-[8px] sm:rounded-xl h-[38px] cursor-pointer border border-[#E2F2FC] bg-white hover:bg-[#F5FAFF] text-[#0E6596] text-sm font-semibold transition-colors overflow-hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0E6596]'"
                [attr.aria-label]="copyLabel() === copiedKey ? t('linkCopied') : t('copyLink')">

                {{ copyLabel() === copiedKey ? t('copied') : t('copy') }}

                @if (copyLabel() === copiedKey) {
                <img [src]="environment.homeImageUrl + 'copied-tik.svg'" aria-hidden="true" class="w-[16px] h-[16px] shrink-0" />
                } @else {
                <img [src]="environment.homeImageUrl + 'copy-03.svg'" aria-hidden="true" class="w-[14px] h-[14px] shrink-0" />
                }

            </button>

        </div>

    </div>
</div>